import { Directive } from '@angular/core';

@Directive({
    selector: '[PrRadioHeader]',
    standalone: false
})
export class EaRadioHeaderDirective {
  constructor() {}
}
